export default __webpack_public_path__ + "static/SiemensProgress-Regula-master-d2de5c084b6273b47d2ee9e9471ae17c.ttf";